import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Quiénes Somos',
    href: '#quienes-somos'
  }, {
    name: 'Menú',
    href: '#menu'
  }, {
    name: 'Domicilios',
    href: '#domicilios'
  }, {
    name: 'Reservas',
    href: '#reservas'
  }, {
    name: 'Sedes',
    href: '#sedes'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <>
      <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-primary/95 backdrop-blur-md py-2 shadow-lg' : 'bg-transparent py-3'}`} data-id="element-236">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-237">
          <div className="flex justify-between items-center" data-id="element-238">
            <a href="#inicio" className="flex-shrink-0" data-id="element-239">
              <Logo height={isScrolled ? 80 : 110} className="transition-all duration-300" data-id="element-240" />
            </a>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center space-x-8" data-id="element-241">
              <div className="flex space-x-6" data-id="element-242">
                {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-cream hover:text-brand-gold text-sm font-medium transition-colors" data-id="element-243">
                    {link.name}
                  </a>)}
              </div>
              <a href="#reservas" className="bg-brand-gold text-brand-primary px-6 py-2 rounded-full font-semibold text-sm hover:bg-yellow-500 transition-colors" data-id="element-244">
                RESERVAR MESA
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center" data-id="element-245">
              <button onClick={() => setIsMobileMenuOpen(true)} className="text-brand-cream hover:text-brand-gold focus:outline-none" aria-label="Abrir menú" data-id="element-246">
                <Menu size={28} data-id="element-247" />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 z-[60] bg-brand-primary flex flex-col" data-id="element-248">
          <div className="flex justify-between items-center p-5 border-b border-brand-gold/20" data-id="element-249">
            <Logo height={80} data-id="element-250" />
            <button onClick={() => setIsMobileMenuOpen(false)} className="text-brand-cream hover:text-brand-gold focus:outline-none" aria-label="Cerrar menú" data-id="element-251">
              <X size={28} data-id="element-252" />
            </button>
          </div>
          <div className="flex flex-col items-center justify-center flex-grow space-y-8 p-4" data-id="element-253">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-brand-cream text-2xl font-serif hover:text-brand-gold transition-colors" data-id="element-254">
                {link.name}
              </a>)}
            <a href="#reservas" onClick={() => setIsMobileMenuOpen(false)} className="bg-brand-gold text-brand-primary px-8 py-3 rounded-full font-bold text-lg mt-4 w-full max-w-xs text-center" data-id="element-255">
              RESERVAR MESA
            </a>
          </div>
        </div>}
    </>;
}